import React, { useCallback, useEffect } from 'react';

import { WizardCardList } from 'src/app/components/lib/wizard/card';

import { isConfigureStepValid } from '../../shared/helpers';
import { useDiscountWizardStateContext } from '../../state';
import { ApplicationMethodTypeId } from '../../types';

import { ApplicationCard } from './application-card';
import { DetailsCard } from './details-card';

import type { WizardStepComponentProps } from 'src/app/components/lib/wizard';

export function Configure({
  disableNextButton,
  disableStepByIndex,
  enableNextButton,
  enableStepByIndex,
  setComplete,
  setIncomplete,
  stepStatus,
}: WizardStepComponentProps) {
  const { configureStepState, isManualDiscount } = useDiscountWizardStateContext();
  const { applicationMethod } = configureStepState;

  const markStepComplete = useCallback(() => {
    enableNextButton();
    setComplete();
  }, [enableNextButton, setComplete]);

  const markStepIncomplete = useCallback(() => {
    disableNextButton();
    setIncomplete();
  }, [disableNextButton, setIncomplete]);

  useEffect(() => {
    const stepIsValid = isConfigureStepValid(configureStepState);
    if (!stepIsValid && stepStatus.complete) {
      markStepIncomplete();
    }
    if (stepIsValid && !stepStatus.complete) {
      markStepComplete();
    }
  }, [configureStepState, markStepComplete, markStepIncomplete, stepStatus]);

  // disable the "Online details" step for manual/loyalty discounts as manual/loyalty discounts are not available in Dutchie eComm
  useEffect(() => {
    if (
      isManualDiscount ||
      applicationMethod === ApplicationMethodTypeId.DutchieLoyalty ||
      applicationMethod === ApplicationMethodTypeId.ExternalLoyalty
    ) {
      disableStepByIndex(4);
    } else {
      enableStepByIndex(4);
    }
  }, [applicationMethod, disableStepByIndex, enableStepByIndex, isManualDiscount]);

  return (
    <WizardCardList $maxWidth='850px'>
      <DetailsCard />
      <ApplicationCard />
    </WizardCardList>
  );
}
